export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  setNewCustomer(state, { payload }) {
    state.customers = [...state.customers, ...[payload]];
  },
  delProperty(state, { property }) {
    state.customers = state.customers.filter(el => el.id !== property);
  },
};
